import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ShippingTargetDialogState } from '../shipping-target-dialog.state';
import { PACKAGE_SPEEDS } from '../../../../_models/shipping-config-rules';
import { ShippingPositionCardComponent } from '../positions/position-card.component';
import { ShippingStationPositionComponent } from '../positions/station-position.component';
import { ShippingTechnicianPositionComponent } from '../positions/technician-position.component';
import { ShippingCustomerPositionComponent } from '../positions/customer-position.component';

/**
 * Seite 2 des Versandziel-Dialogs: alle Positionen des gewählten Versandtyps
 * untereinander, jede sofort bearbeitbar. Die Reihenfolge kommt aus
 * shipping-target-positions.ts, die Gültigkeit aus dem State.
 */
@Component({
  standalone: true,
  selector: 'hawk-shipping-positions-page',
  imports: [
    FormsModule,
    FontAwesomeModule,
    ShippingPositionCardComponent,
    ShippingStationPositionComponent,
    ShippingTechnicianPositionComponent,
    ShippingCustomerPositionComponent,
  ],
  templateUrl: './positions-page.component.html',
})
export class ShippingPositionsPageComponent {
  protected state = inject(ShippingTargetDialogState);
  protected packageSpeeds = PACKAGE_SPEEDS;
}
